import {configureStore} from "@reduxjs/toolkit";
import analysisReducer from "./analysisStore";
//	组合子模块的store
const store = configureStore({
    reducer: {
        //	存储器名：reducer
        analysis: analysisReducer
    }
})
export default store